import PopularGames from "../../components/popular-games";
import CasinoListItem from "./item";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import NoData from "../../components/no-data";
import {useTranslation} from "react-i18next";
import Loading from "../../components/loading";
import GeneralStats from "../../components/debit-table/casino-debit-stats";
import TopGames from "../../components/top-games";
import {Swiper, SwiperSlide} from "swiper/react";
import {points} from "../../helpers/splide-helper";
import SlideGameItem from "../../components/slide-game-item";
import {useSelector} from "react-redux";

const Favorites = () => {
    const {configuration} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()
    const [loading, setLoading] = useState(true)
    // const [total, setTotal] = useState(0)
    const [data, setData] = useState([])
    useEffect(() => {

        associateServices.getFavorites({
            page: 1,
            limit: 20,
            sortBy: 'name',
            direction: 'desc',
        }).then(res => {

            setData(res?.data?.games || [])
            // setTotal(res?.data?.games?.total || 0)
            setLoading(false)
        })
    }, [])

    return (
        <>
            <div className="section section--first">
                <div className="container">
                    <div className="section__title-wrap">
                        <h2 className="section__title">{t('favorites.title')}</h2>
                    </div>
                    <div className="container-fluid p-0">
                        <div className="row gx-2 gx-sm-3 gx-md-4">
                            {
                                loading ? <Loading/> : data?.length <= 0 ? <NoData desc={t('favorites.empty')}/> :
                                    <div className="d-flex flex-column gap-2">
                                        <Swiper
                                            spaceBetween={8} // Space between slides
                                            slidesPerView={3} // This defines 2 slides per row
                                            grid={{
                                                fill: "row", // Ensures rows are filled row by row
                                            }}
                                            breakpoints={points}
                                            loop={true}
                                            autoplay={{
                                                delay: 5000,
                                                disableOnInteraction: false,
                                            }}
                                            className="top-games-bottom"
                                        >
                                            {data?.map((game, i) => (
                                                <SwiperSlide key={i}>
                                                    <SlideGameItem
                                                        game={game}
                                                        index={i}
                                                        showCount={false}
                                                        passive={game?.blacklist?.includes(configuration.country)}
                                                    />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <TopGames/>

            <div className="section pt-24">
                <PopularGames/>
            </div>

            <GeneralStats/>
        </>

    )

}

export default Favorites
